import React, { PropsWithChildren, ReactNode, ComponentProps } from "react";

import "./Tip.scss";

interface TipProps extends ComponentProps<"div"> {
  icon: ReactNode;
}

export function Tip({
  children,
  icon,
  className = "",
  ...restProps
}: PropsWithChildren<TipProps>) {
  return (
    <div
      role="alert"
      className={`tip slashed-zero d-flex justify-content-center align-items-center ${className}`}
      {...restProps}
    >
      {icon}
      <p>{children}</p>
    </div>
  );
}

export default Tip;
